<template>
	<div class="DataCrisis">
		<div v-for="(item, index) in (scale === 993548 ? ['症状状况'] : text)" :key="index">
			<div class="tags">
				<i :style="{background: color[index]}"></i>
				<span>{{item}}</span>
			</div>
			<div class="imgs"><radarView v-if="list" :data="list[index]" :total="total" :tip="tooltip[index]" :color="color[index]"></radarView></div>
		</div>
	</div>
</template>

<script>
import radarView from './radarView'
export default {
	name: 'DataCrisis',
	props: ['dataOne', 'dataTwo', 'total', 'scale'],
	data () {
		return {
			text: ['症状状况', '压力水平', '韧性水平'],
			color: ['#FF5219', '#FF9200', '#00B042'],
			tooltip: ['异常人数比例', '受影响人数比例', '需提升人数比例'],
			list: null
		}
	},
	components: {
		radarView
	},
	computed: {
		newParams () {
			return {dataOne: this.dataOne, dataTwo: this.dataTwo}
		}
	},
	watch: {
		newParams () {
			let imgsOne, imgsTwo, imgsThree
			if (this.dataOne) {
				imgsOne = {
					text: [
						{text: '强迫', max:100},
						{text: '焦虑', max:100},
						{text: '抑郁', max:100},
						{text: '睡眠', max:100},
						{text: '偏执', max:100},
						{text: '敌对', max:100},
						{text: '人际敏感', max:100}
					],
					data: [this.dataOne.FORCEEQUALL, this.dataOne.ANXIOUSEQUALL, this.dataOne.BLUES_ALL, this.dataOne.LOSE_SLEEP_ALL, this.dataOne.PARANOIAEQUALL, this.dataOne.HOSTILEEQUALL, this.dataOne.SENSITIVEEQUALL]
				}
				imgsTwo = {
					text: [
						{text: '学习压力', max:100},
						{text: '人际压力', max:100},
						{text: '适应压力', max:100},
						{text: '受惩罚压力', max:100},
						{text: '丧失压力', max:100}
					],
					data: [this.dataOne.ACADEMICSTRESS, this.dataOne.INTERPERSONAL, this.dataOne.HEALTH, this.dataOne.CATCHHELL, this.dataOne.LOST]
				}
			}
			if (this.dataTwo) {
				imgsThree = {
					text: [
						{text: '家庭支持', max:100},
						{text: '情绪管理', max:100},
						{text: '人际支持', max:100},
						{text: '积极关注', max:100},
						{text: '学校支持', max:100},
						{text: '目标激励', max:100}
					],
					data: [this.dataTwo.FAMILYSCORE, this.dataTwo.EMOTIONALSCORE, this.dataTwo.INTERPERSONAL_SUPPORT, this.dataTwo.ACTIVESCORE, this.dataTwo.SCHOOLSCORE, this.dataTwo.TARGETESCORE]
				}
			}
			this.list = [imgsOne, imgsTwo, imgsThree] // 症状、压力、韧性
		}
	},
	mounted () {
		let imgsOne, imgsTwo, imgsThree
		if (this.dataOne) {
			imgsOne = {
				text: [
					{text: '强迫', max:100},
					{text: '焦虑', max:100},
					{text: '抑郁', max:100},
					{text: '睡眠', max:100},
					{text: '偏执', max:100},
					{text: '敌对', max:100},
					{text: '人际敏感', max:100}
				],
				data: [this.dataOne.FORCEEQUALL, this.dataOne.ANXIOUSEQUALL, this.dataOne.BLUES_ALL, this.dataOne.LOSE_SLEEP_ALL, this.dataOne.PARANOIAEQUALL, this.dataOne.HOSTILEEQUALL, this.dataOne.SENSITIVEEQUALL]
			}
			imgsTwo = {
				text: [
					{text: '学习压力', max:100},
					{text: '人际压力', max:100},
					{text: '适应压力', max:100},
					{text: '受惩罚压力', max:100},
					{text: '丧失压力', max:100}
				],
				data: [this.dataOne.ACADEMICSTRESS, this.dataOne.INTERPERSONAL, this.dataOne.HEALTH, this.dataOne.CATCHHELL, this.dataOne.LOST]
			}
		}
		if (this.dataTwo) {
			imgsThree = {
				text: [
					{text: '家庭支持', max:100},
					{text: '情绪管理', max:100},
					{text: '人际支持', max:100},
					{text: '积极关注', max:100},
					{text: '学校支持', max:100},
					{text: '目标激励', max:100}
				],
				data: [this.dataTwo.FAMILYSCORE, this.dataTwo.EMOTIONALSCORE, this.dataTwo.INTERPERSONAL_SUPPORT, this.dataTwo.ACTIVESCORE, this.dataTwo.SCHOOLSCORE, this.dataTwo.TARGETESCORE]
			}
		}
		this.list = [imgsOne, imgsTwo, imgsThree] // 症状、压力、韧性
	}
}
</script>

<style scoped>
.DataCrisis {
	display: flex;
	justify-content: space-between;
	padding-bottom: 24px!important;
}
.DataCrisis > div {
	flex: 1;
	margin-right: 14px;
}
.DataCrisis > div:last-child {
	margin: 0px;
}
.DataCrisis .tags {
	display: flex;
	align-items: center;
	margin-bottom: 16px;
	color: #262626;
	font-size: 14px;
}
.DataCrisis .tags i {
	width: 4px;
	height: 14px;
	margin-right: 8px;
}
.DataCrisis .imgs {
	border: 1px solid #D9D9D9;
	background: #F5F5F5;
}
</style>
